import { Spinner } from "@chakra-ui/react";

const Loading = () => {
  return <Spinner />;
};

export default Loading;
